import { TFunction } from "i18next";

import {
  ERRORS,
  isLabelItem,
  isTranslatableItem,
  SimpleResult,
} from "@prostocheck/shared";

/**
 * Turns a failed `SimpleResult` into the sentence a user reads, in whichever
 * language is active. This is the only place that decides it: libraries carry
 * translation keys, never text.
 *
 * A result that succeeded has nothing to say — the caller checks `success`
 * first, and gets the fallback if it did not.
 */
export const simpleResultErrorMessage = <T>({
  result,
  t,
}: {
  result: SimpleResult<T>;
  t: TFunction;
}): string => {
  const { error } = result;

  if (isTranslatableItem(error)) {
    return t(error.translationKey, error.translationParams);
  }

  if (isLabelItem(error)) {
    return error.label;
  }

  if (Array.isArray(error)) {
    return error.join(", ");
  }

  if (typeof error === "string") {
    return error;
  }

  // An Error's message is developer text in one language; it belongs in the
  // console, not on screen.
  return t(ERRORS.common.unknown);
};
